import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { helpers } from 'react-wot-bootstrap'

import { INDUSTRIAL_RESOURCE_MULTIPLIER, INDUSTRIAL_RESOURCE_MULTIPLIER_TEXT } from 'helpers/i18n'
import { closeBattleRoomsList } from 'helpers/web_to_client'
import { isPlayersMatchingAvailable } from 'helpers/playersMatching'

import { KEY_CODES } from 'constants'
import IndustrialResourceCoefTooltip from 'components/IndustrialResourceCoefTooltip/IndustrialResourceCoefTooltip'

import CreateUnitButton from '../CreateUnitButton/CreateUnitButton'
import Tabs from '../Tabs/Tabs'
import Title from '../Title/Title'

import {
    BATTLE_ROOMS_TITLE,
} from '../../constants'

import styles from './BattleRoomsWrapper.scss'

export class BattleRoomsWrapper extends React.Component {

    static propTypes = {
        clanId: PropTypes.number,
        isVehiclesFilterOpen: PropTypes.bool.isRequired,
        playersMatchingAvailable: PropTypes.bool,
        realm: PropTypes.string.isRequired,
        industrialResourceMultiplier: PropTypes.number.isRequired,
    }

    componentWillMount() {
        window.addEventListener('keydown', this.onKeyDown)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown)
    }

    onKeyDown = event => {
        if (event.keyCode === KEY_CODES.ESCAPE && !this.props.isVehiclesFilterOpen) {
            closeBattleRoomsList()
        }
    }

    render() {
        const className = classNames(styles.base, {
            [styles.base__cn]: helpers.isChineseRealm(this.props.realm),
        })

        return (
            <div className={className}>
                <header className={styles.header}>
                    <Title>
                        {BATTLE_ROOMS_TITLE}
                        {this.props.industrialResourceMultiplier > 1 &&
                            <div className={styles.multiplier} data-tip data-for={IndustrialResourceCoefTooltip.id}>
                                {INDUSTRIAL_RESOURCE_MULTIPLIER_TEXT(
                                    <span className={styles.multiplierValue}>
                                        {INDUSTRIAL_RESOURCE_MULTIPLIER(this.props.industrialResourceMultiplier)}
                                    </span>
                                )}
                            </div>
                        }
                    </Title>
                    {this.props.clanId && (
                        <div className={styles.createUnit}>
                            <CreateUnitButton />
                        </div>
                    )}
                    {this.props.industrialResourceMultiplier > 1 &&
                        <IndustrialResourceCoefTooltip multiplier={this.props.industrialResourceMultiplier} />
                    }
                </header>
                <main className={styles.holder}>
                    {this.props.playersMatchingAvailable && (
                        <div className={styles.tabs}>
                            <Tabs />
                        </div>
                    )}
                    {this.props.children}
                </main>
            </div>
        )
    }
}

const mapStateToProps = ({ account, players_matching, clan, settings }) => {
    const playersMatchingAvailable = isPlayersMatchingAvailable(account, players_matching)

    return {
        clanId: clan.id,
        isVehiclesFilterOpen: players_matching.isVehiclesFilterOpen,
        playersMatchingAvailable,
        realm: settings.realm,
        industrialResourceMultiplier: settings.industrialResourceMultiplier,
    }
}

export default connect(mapStateToProps)(BattleRoomsWrapper)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleRoomsWrapper/BattleRoomsWrapper.jsx